"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
class HostServiceDE extends _host.HostService {
  constructor(params) {
    var _params$config, _params$config$devSet;
    super(params);
    this.openInNewTab = params === null || params === void 0 ? void 0 : (_params$config = params.config) === null || _params$config === void 0 ? void 0 : (_params$config$devSet = _params$config.devSettings) === null || _params$config$devSet === void 0 ? void 0 : _params$config$devSet.openDeepLinksNewTab;
  }
}
var _default = HostServiceDE;
exports.default = _default;